import type { Attachment } from '@nexo/types';
import { useSyncExternalStore } from 'react';

export interface ViewerState {
  files: Attachment[];
  index: number;
}

let state: ViewerState | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

/** Global in-app file viewer (lightbox). */
export const viewer = {
  open: (files: Attachment[], index = 0) => {
    state = { files, index };
    emit();
  },
  close: () => {
    state = null;
    emit();
  },
  go: (delta: number) => {
    if (!state || state.files.length < 2) return;
    state = { ...state, index: (state.index + delta + state.files.length) % state.files.length };
    emit();
  },
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export const useViewer = () => useSyncExternalStore(viewer.subscribe, () => state);
